import { format } from 'date-fns';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import { IOrganization } from '@Data/organizations/Interfaces';
import { IProject } from '@Data/projects/Interfaces';
import { ITeam } from '@Data/teams/Interfaces';

export function splitCamelCase(s: string, forceTitleCase?: boolean): string {
    const strArray = s.split('_');
    const splitArrStr = strArray.join(' ');
    return forceTitleCase
        ? splitArrStr.replace(splitArrStr[0], splitArrStr[0].toUpperCase())
        : splitArrStr;
}

export function getTimestampStr(userDate?: Date): string {
    const date = _isNil(userDate) ? new Date(Date.now()) : userDate;
    return format(date, 'yMMddHHmm');
}

export function getHumanReadableDateTime(rawDate: string | number): string {
    return format(new Date(rawDate), 'dd MMM y, h:mm aaa');
}

export function isValidEmail(email: string): boolean {
    const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email);
}

export const isUrl = (str: string) => {
    return str && str.includes('http');
};

export const getBreadCrumbsString = (
    selectedOrg: IOrganization | null,
    selectedTeam: ITeam | null,
    selectedProject: IProject | null
) => {
    let breadCrumbsString = '';
    if (selectedOrg) {
        breadCrumbsString += selectedOrg.organisation_name;
    }
    if (selectedTeam) {
        breadCrumbsString += `  >  ${selectedTeam.team_name}`;
    }
    if (selectedProject) {
        breadCrumbsString += `  >  ${selectedProject.project_name}`;
    }
    return breadCrumbsString;
};

export function isTextClamped(element: HTMLElement) {
    return element.scrollHeight > element.clientHeight;
}

export const createWireLabelText = (wire) => {
    const wireSizeArr = wire.fields.find(
        (field) => field.name === 'Size'
    ).value;
    if (_isEmpty(wireSizeArr)) {
        return null;
    } else {
        const wireSizeValuesArr = wireSizeArr.map((element) => element.value);
        const wireTitle = wireSizeValuesArr.join(' > ');
        return wireTitle;
    }
};

export const createAnchorLabelText = (anchor) => {
    const anchorOwnerArr = anchor.fields.find(
        (field) => field.name === 'Owner'
    ).value;
    if (_isEmpty(anchorOwnerArr)) {
        return null;
    } else {
        const anchorOwnerValuesArr = anchorOwnerArr.map(
            (element) => element.value
        );
        const anchorTitle = anchorOwnerValuesArr.join(' > ');
        return anchorTitle;
    }
};

export const createAttachmentLabelText = (attachment) => {
    const attachmentTypeValueObj = attachment.fields.find(
        (field) => field.name === 'Type'
    ).value;
    if (_isEmpty(attachmentTypeValueObj)) {
        return null;
    } else {
        const attachmentTitle = attachmentTypeValueObj.title;
        return attachmentTitle;
    }
};
